import Icon from '../components/Icon.vue'

Icon.register({
  'grin-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM328 152c-23.8 0-52.7 29.3-55.8 71.4-0.7 8.5 10.8 11.8 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4zM168 152c-23.8 0-52.7 29.3-55.8 71.4-0.7 8.5 10.7 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4zM248 432c60.6 0 134.5-38.3 143.8-93.3 1.9-11.8-9.3-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.3-3.7-22.7 6-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-beam.js
// module id = 1401
// module chunks = 0